import React, { ReactElement, createContext, FC, useContext, useState } from 'react'
import { IBallot } from '../../api/types'
import { loadPersistentState, savePersistentState } from '../../utils/localStorageIO'
import { useUserState } from '../UserProvider/UserProvider'
import { TBallotContext, TBallotStorage, TBallotUserQuestions } from './types'

const BallotContext = createContext<TBallotContext>([{}, () => ({})])

const storageKey = 'pollabBallots'
type Props = {
    children: ReactElement
}

const BallotStateProvider: FC<Props> = ({ children }) => {
    const user = useUserState()

    const getInit = (): TBallotUserQuestions => {
        try {
            const storage = loadPersistentState<TBallotStorage>(storageKey) || {}
            return storage[user.uuid]
        } catch (ignore) {
            return {}
        }
    }

    const [state, setState] = useState<TBallotUserQuestions>(getInit())

    const addBallot = (voted: IBallot): TBallotUserQuestions => {
        let _storage = { [user.uuid]: state }
        try {
            _storage = loadPersistentState<TBallotStorage>(storageKey) || {}
        } catch (ignore) {}
        const storage = { ..._storage }

        if (!storage[user.uuid]) {
            storage[user.uuid] = {}
        }
        if (!storage[user.uuid][voted.question]) {
            storage[user.uuid][voted.question] = []
        }
        if (!storage[user.uuid][voted.question]) {
            storage[user.uuid][voted.question] = []
        }
        storage[user.uuid][voted.question] = [
            ...storage[user.uuid][voted.question],
            ...voted.options,
        ]
            .sort()
            .filter((item, index, arr) => !index || item != arr[index - 1])

        setState(storage[user.uuid])
        try {
            savePersistentState<TBallotStorage>(storageKey, storage)
        } catch (ignore) {}

        return storage[user.uuid]
    }

    return <BallotContext.Provider value={[state, addBallot]}>{children}</BallotContext.Provider>
}

function useBallotState(): TBallotContext {
    const context = useContext(BallotContext)
    if (context === undefined) {
        throw new Error('useBallotState must be used within a BallotContext')
    }
    return context
}

export { BallotStateProvider, useBallotState }
